'use client';
import {FC, useState} from 'react';
import styles from './FooterComponent.module.scss';
import Link from 'next/link';
import Letter from '../../app/assets/icons/letter.svg';
import Twitter from '../../app/assets/icons/twitter.svg';
import Telegram from '../../app/assets/icons/telegram-2.svg';
import Instagram from '../../app/assets/icons/instagram.svg';
import Image from 'next/image';
import {useTranslations} from 'next-intl';
import Logo from "../../app/assets/icons/logo.svg";
import classNames from "classnames";

interface FooterComponentProps {
  className?: string;
  forceVisible?: boolean;
}

const FooterComponent: FC<FooterComponentProps> = (
  {
    className = '',
    forceVisible = false,
  }) => {
  const t = useTranslations('FOOTER_COMPONENT');
  const year = new Date().getFullYear();

  return (
    <>
      <footer className={classNames(styles.root, className, {[styles.mobileHide]: !forceVisible})}>
        <div className={styles.info}>
          <Link prefetch={false} href="/" className={styles.info__logo}>
            <Image src={Logo} alt="logo"/>
          </Link>
          <p className={styles.info__disc}>{t('use')} © 2022 - {year}</p>

          <div className={styles.info__social}>
            <a
              className={`${styles.social__link}`}
              target="_blank"
              href={process.env.NEXT_PUBLIC_SUPPORT_URL}>
              <Image src={Letter} alt="Letter"/>
            </a>
            <a className={styles.social__link} target="_blank" href={process.env.NEXT_PUBLIC_TELEGRAM_URL}>
              <Image src={Telegram} alt="telegram"/>
            </a>
            <a className={styles.social__link} target="_blank" href={process.env.NEXT_PUBLIC_TWITTER_URL}>
              <Image src={Twitter} alt="Twitter"/>
            </a>
            <a className={styles.social__link} target="_blank" href={process.env.NEXT_PUBLIC_INSTAGRAM_URL}>
              <Image src={Instagram} alt="Instagram"/>
            </a>
          </div>
          <small className={styles.recaptcha_disclaimer}>This site is protected by reCAPTCHA and the
            Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.
          </small>
        </div>
        <div className={styles.links}>
          <div className={styles.linkGroup}>
            <span>{t('links')}</span>
            <nav className={styles.navigation}>
              <Link className={styles.navigation__link} href={process.env.NEXT_PUBLIC_CONSOLE_URL || "#"} target={"_blank"}>
                {t('console_for_organizers')}
              </Link>
              <Link className={styles.navigation__link} href={process.env.NEXT_PUBLIC_DOCS_URL || "#"} target={"_blank"}>
                {t('knowledge_base')}
              </Link>
              <Link className={styles.navigation__link} href={process.env.NEXT_PUBLIC_TICKET_REFUND_URL || "#"} target={"_blank"}>
                {t('how_to_refund_a_ticket')}
              </Link>
              <Link className={styles.navigation__link} href={process.env.NEXT_PUBLIC_HOW_TO_CREATE_EVENT_URL || "#"} target={"_blank"}>
                {t('how_to_create_an_event')}
              </Link>
              <Link className={styles.navigation__link} href={process.env.NEXT_PUBLIC_HOW_TO_SELL_WITH_TELEGRAM_URL || "#"} target={"_blank"}>
                {t('how_to_sell_tickets_with_telegram')}
              </Link>
            </nav>
          </div>
          <div className={styles.linkGroup}>
            <span>{t('legal')}</span>
            <nav className={styles.navigation}>
              <Link className={styles.navigation__link} href={process.env.NEXT_PUBLIC_PRIVACY_POLICY_URL || "#"} target={"_blank"}>
                {t('privacy_policy')}
              </Link>
              <Link className={styles.navigation__link} href={process.env.NEXT_PUBLIC_PUBLIC_OFFER_URL || "#"} target={"_blank"}>
                {t('public_offer')}
              </Link>
              <Link className={styles.navigation__link} href={process.env.NEXT_PUBLIC_TICKET_PURCHASE_POLICY_URL || "#"} target={"_blank"}>
                {t('ticket_purchase_policy')}
              </Link>
              <Link className={styles.navigation__link} href={process.env.NEXT_PUBLIC_EVENT_POSTING_GUIDELINES_URL || "#"} target={"_blank"}>
                {t('event_posting_guidelines')}
              </Link>
              <Link className={styles.navigation__link} href={process.env.NEXT_PUBLIC_SUBSCRIPTION_PURCHASE_POLICY_URL || "#"} target={"_blank"}>
                {t('subscription_purchase_policy')}
              </Link>
            </nav>
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterComponent;
